<template>
  <div class="saas-404">
    <img src="/images/404.png" alt="" />
    <div>
      <h1>{{ hostName }} 地址不正确</h1>
      <div class="text">
        <p><i />请确认企业已开通服务</p>
        <p><i />如企业已开通服务，请联系系统管理员确认访问地址</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      hostName: '',
    };
  },
  async created() {
    this.hostName = window.location.hostname;
  },
};
</script>
<style lang="scss" scoped>
.saas-404 {
  background: #fff;
  height: 100%;
  position: fixed;
  width: 100%;
  left: 0;
  justify-content: center;
  display: flex;
  align-items: center;
  bottom: 0;
  img {
    width: 482px;
    display: block;
    margin-right: 6%;
  }
  h1 {
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
    font-weight: 700;
    font-style: normal;
    font-size: 28px;
    line-height: 28px;
    margin-bottom: 18px;
  }
  .text {
    line-height: 50px;
    font-size: 18px;
    color: #666666;
    p {
      display: flex;
      align-items: center;
    }
    i {
      display: block;
      width: 15px;
      height: 15px;
      background: #ff4f52;
      border-radius: 50%;
      margin-right: 10px;
    }
  }
}
</style>
